import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    shareholderEvents: [],
    shareholderEvent: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.shareholderEvents = [];
      state.shareholderEvent = null;
    },
    SET_SHAREHOLDER_EVENTS(state, data) {
      state.shareholderEvents = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SHAREHOLDER_EVENT(state, data) {
      state.shareholderEvent = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setShareholderEvent({ commit }, data) {
      commit('SET_SHAREHOLDER_EVENT', data);
    },

    find({ commit, state }) {
      let url = `/shareholder_events?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('IR'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SHAREHOLDER_EVENTS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/shareholder_events/${id}`)
        .then((response) => response.body)
        .then(typeAs('IR'))
        .then((item) => {
          commit('SET_SHAREHOLDER_EVENT', item);
        });
    },

    destroy(_, id) {
      return http(`/shareholder_events/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/shareholder_events/${id}`, { method: 'PUT', data })
        : http('/shareholder_events', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
